<template>
  <div class="form_box">
    <div v-if="auditState === 0" class="fail_reason">
      <div class="fail_title">未通过原因</div>
      <div class="fail_desc" :title="(reason.length > 51)? reason : ''">{{reason}}</div>
    </div>
    <el-form class="info_form" size="mini" :model="formData" label-width="130px" ref="form">
      <el-form-item class="img_info" label="资质证件">
        <div class="doc_box">
          <p class="doc_title">1.请上传营业执照</p>
          <UploadImage :img-src.sync="formData.businessLicenseUrl">
            营业执照
            <span class="sub">(小于5M)</span>
          </UploadImage>
        </div>
        <span class="box_line"></span>
        <div class="doc_box">
          <p class="doc_title">2.请上传法人身份证正反面</p>
          <UploadImage class="fl" :img-src.sync="formData.cardFrontUrl">
            法人身份证正面
            <span class="sub">(小于5M)</span>
          </UploadImage>
          <UploadImage class="fl mgl20" :img-src.sync="formData.cardBackUrl">
            法人身份证反面
            <span class="sub">(小于5M)</span>
          </UploadImage>
        </div>
      </el-form-item>
      <el-form-item label="公司名称">
        <el-input
          placeholder="公司名称需与营业执照保持一致"
          maxlength="40"
          suffix-icon="iconfont icon-biaodan-tianxie"
          v-model="formData.customerName"
          @input="v => { formData.customerName = v.trim() }">
        </el-input>
      </el-form-item>
      <el-form-item label="法人姓名">
        <el-input
          placeholder="法人姓名需与营业执照保持一致"
          maxlength="20"
          suffix-icon="iconfont icon-biaodan-tianxie"
          v-model="formData.legalPerson"
          @input="v => { formData.legalPerson = v.trim() }">
        </el-input>
      </el-form-item>
      <el-form-item label="企业验证类型">
        <el-select
          class="width100"
          placeholder="请选择"
          v-model="formData.companyType">
          <el-option
            v-for="{label, value} in companyTypes"
            :key="value"
            :label="label"
            :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人姓名">
        <el-input
          placeholder="请输入"
          maxlength="20"
          suffix-icon="iconfont icon-biaodan-tianxie"
          v-model="formData.contacter"
          @input="v => { formData.contacter = v.trim() }">
        </el-input>
      </el-form-item>
      <el-form-item label="联系人电话">
        <el-input
          placeholder="请输入"
          maxlength="16"
          suffix-icon="iconfont icon-biaodan-tianxie"
          v-model="formData.contactPhone"
          @input="inputPhone">
        </el-input>
      </el-form-item>
    </el-form>
    <ad-button class="save_btn" :width="210" :height="40" @click="saveInfo">
      {{auditState === -2 ? '提交审核' : '重新提交审核'}}
    </ad-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import firmPerson from '../mixin/firmperson'

export default {
  name: 'FormFirm',
  mixins: [ firmPerson ],
  data () {
    return {
      adType: 2,
      formData: {
        advertiserType: null,
        businessLicenseUrl: '',
        cardFrontUrl: '',
        cardBackUrl: '',
        customerName: '',
        legalPerson: '',
        companyType: undefined,
        contacter: '',
        contactPhone: '',
      }
    }
  },
  computed: {
    ...mapState({
      companyTypes: state => {
        return state.customer.COMPANY_TYPE
      }
    })
  },
  async created () {
    if (!this.companyTypes.length) await this.$store.dispatch('customer/getCusDic', 'COMPANY_TYPE')
  }
}
</script>

<style lang="scss" scoped>
@import '../style/firmPerson'
</style>
